/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ElementModel } from './ElementModel';
import {
    ElementModelFromJSON,
    ElementModelFromJSONTyped,
    ElementModelToJSON,
} from './ElementModel';
import type { EpisodeAccessModel } from './EpisodeAccessModel';
import {
    EpisodeAccessModelFromJSON,
    EpisodeAccessModelFromJSONTyped,
    EpisodeAccessModelToJSON,
} from './EpisodeAccessModel';
import type { EpisodeSummaryModel } from './EpisodeSummaryModel';
import {
    EpisodeSummaryModelFromJSON,
    EpisodeSummaryModelFromJSONTyped,
    EpisodeSummaryModelToJSON,
} from './EpisodeSummaryModel';
import type { SeriesSummaryModel } from './SeriesSummaryModel';
import {
    SeriesSummaryModelFromJSON,
    SeriesSummaryModelFromJSONTyped,
    SeriesSummaryModelToJSON,
} from './SeriesSummaryModel';
import type { ViewerSettingInfoModel } from './ViewerSettingInfoModel';
import {
    ViewerSettingInfoModelFromJSON,
    ViewerSettingInfoModelFromJSONTyped,
    ViewerSettingInfoModelToJSON,
} from './ViewerSettingInfoModel';

/**
 * 作品内の1エピソードを表します。
 * @export
 * @interface EpisodeModel
 */
export interface EpisodeModel {
    /**
     * エピソードを一意に識別するID
     * @type {string}
     * @memberof EpisodeModel
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof EpisodeModel
     */
    indexId?: number;
    /**
     * 
     * @type {SeriesSummaryModel}
     * @memberof EpisodeModel
     */
    series: SeriesSummaryModel;
    /**
     * 
     * @type {EpisodeSummaryModel}
     * @memberof EpisodeModel
     */
    summary: EpisodeSummaryModel;
    /**
     * エピソードのコンテンツ。アクセス権がない場合は設定されません。
     * @type {Array<ElementModel>}
     * @memberof EpisodeModel
     */
    content?: Array<ElementModel>;
    /**
     * 記事本文データのJson文字列データ
     * エピソードのタイプがマンガ以外で記事本文データがJson形式の場合に設定されます
     * (Json形式の記事本文データが content に正常にマッピングできず、データが欠落する場合があるために用意)
     * @type {string}
     * @memberof EpisodeModel
     */
    contentRowJson?: string;
    /**
     * 
     * @type {EpisodeAccessModel}
     * @memberof EpisodeModel
     */
    access: EpisodeAccessModel;
    /**
     * 作品の最初エピソードのID。存在しない場合は値を返しません。
     * @type {string}
     * @memberof EpisodeModel
     */
    firstEpisodeId?: string;
    /**
     * 前のエピソードのID。存在しない場合は値を返しません。
     * @type {string}
     * @memberof EpisodeModel
     */
    previousEpisodeId?: string;
    /**
     * 次のエピソードのID。存在しない場合は値を返しません。
     * @type {string}
     * @memberof EpisodeModel
     */
    nextEpisodeId?: string;
    /**
     * 作品の中でエピソードの番目
     * @type {number}
     * @memberof EpisodeModel
     */
    seriesEpisodeNumber?: number;
    /**
     * 管理者モードフラグ
     * @type {boolean}
     * @memberof EpisodeModel
     */
    isAdminMode?: boolean;
    /**
     * 「ファンレターを送る」で開くURLの情報。
     * @type {string}
     * @memberof EpisodeModel
     */
    fanLetterUrl?: string;
    /**
     * 「Xでシェア」した時に自動入力されるハッシュタグ等の情報。
     * @type {string}
     * @memberof EpisodeModel
     */
    shareMessage?: string;
    /**
     * 
     * @type {ViewerSettingInfoModel}
     * @memberof EpisodeModel
     */
    viewer?: ViewerSettingInfoModel;
}

/**
 * Check if a given object implements the EpisodeModel interface.
 */
export function instanceOfEpisodeModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "series" in value;
    isInstance = isInstance && "summary" in value;
    isInstance = isInstance && "access" in value;

    return isInstance;
}

export function EpisodeModelFromJSON(json: any): EpisodeModel {
    return EpisodeModelFromJSONTyped(json, false);
}

export function EpisodeModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EpisodeModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'indexId': !exists(json, 'indexId') ? undefined : json['indexId'],
        'series': SeriesSummaryModelFromJSON(json['series']),
        'summary': EpisodeSummaryModelFromJSON(json['summary']),
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(ElementModelFromJSON)),
        'contentRowJson': !exists(json, 'contentRowJson') ? undefined : json['contentRowJson'],
        'access': EpisodeAccessModelFromJSON(json['access']),
        'firstEpisodeId': !exists(json, 'firstEpisodeId') ? undefined : json['firstEpisodeId'],
        'previousEpisodeId': !exists(json, 'previousEpisodeId') ? undefined : json['previousEpisodeId'],
        'nextEpisodeId': !exists(json, 'nextEpisodeId') ? undefined : json['nextEpisodeId'],
        'seriesEpisodeNumber': !exists(json, 'seriesEpisodeNumber') ? undefined : json['seriesEpisodeNumber'],
        'isAdminMode': !exists(json, 'isAdminMode') ? undefined : json['isAdminMode'],
        'fanLetterUrl': !exists(json, 'fanLetterUrl') ? undefined : json['fanLetterUrl'],
        'shareMessage': !exists(json, 'shareMessage') ? undefined : json['shareMessage'],
        'viewer': !exists(json, 'viewer') ? undefined : ViewerSettingInfoModelFromJSON(json['viewer']),
    };
}

export function EpisodeModelToJSON(value?: EpisodeModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'indexId': value.indexId,
        'series': SeriesSummaryModelToJSON(value.series),
        'summary': EpisodeSummaryModelToJSON(value.summary),
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(ElementModelToJSON)),
        'contentRowJson': value.contentRowJson,
        'access': EpisodeAccessModelToJSON(value.access),
        'firstEpisodeId': value.firstEpisodeId,
        'previousEpisodeId': value.previousEpisodeId,
        'nextEpisodeId': value.nextEpisodeId,
        'seriesEpisodeNumber': value.seriesEpisodeNumber,
        'isAdminMode': value.isAdminMode,
        'fanLetterUrl': value.fanLetterUrl,
        'shareMessage': value.shareMessage,
        'viewer': ViewerSettingInfoModelToJSON(value.viewer),
    };
}

